import { useForm, router } from '@inertiajs/vue3';
import { logout as logoutRoute } from '@/routes';

export default function useAuth() {
  const logout = () => router.visit(logoutRoute.url(), { method: 'post' });
  const signInForm = useForm<{
    email: string;
    password: string;
    remember: boolean;
  }>({
    email: '',
    password: '',
    remember: false,
  });

  return {
    signInForm,
    logout,
  };
}
